export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14265.d759bf76.jpg";